export default function getCsrfToken() {
  const metaCsrfTag =
    document.head.querySelector('meta[name="csrf"]') ||
    document.head.querySelector('meta[name="csrf-token"]');

  return metaCsrfTag ? metaCsrfTag.content : null;
}
